import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      await axios.post('/api/auth/forgot-password', { email });
      setMessage('Si l\'email existe, un lien de réinitialisation a été envoyé.');
    } catch (err) {
      setError(err.response?.data?.message || 'Échec de l\'envoi de l\'email de réinitialisation');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#141414] flex flex-col overflow-x-hidden">
      <Header />

      {/* Background + Modal */}
      <div className="flex-1 relative">
        {/* Overlay */}
        <div className="absolute inset-0 bg-[#141414] backdrop-blur-sm" />

        {/* Centered Modal */}
        <div className="relative z-10 w-full max-w-[1240px] mx-auto px-4 py-12 min-h-[calc(100vh-140px)] flex items-center justify-center">
          <div className="w-full max-w-[560px] bg-[#1A1A1A] border border-[#262626] rounded-3xl p-6 sm:p-8 shadow-2xl relative">
            {/* Close */}
            <Link
              to="/login"
              className="absolute top-5 right-5 text-white/70 hover:text-white transition"
              aria-label="Close"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path
                  d="M6 6L18 18M6 18L18 6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </Link>

            <h2 className="text-3xl font-semibold text-white text-center">
              Mot de passe oublié
            </h2>
            <p className="text-white/50 text-center mt-2">
              Nous vous enverrons un lien par email pour réinitialiser votre mot de passe
            </p>

            {/* Alerts */}
            {error && (
              <div className="mt-6 p-3 bg-red-900/50 border border-red-700 rounded-lg text-red-200 text-sm">
                {error}
              </div>
            )}

            {message && (
              <div className="mt-6 p-3 bg-green-900/50 border border-green-700 rounded-lg text-green-200 text-sm">
                {message}
              </div>
            )}

            <form onSubmit={handleSubmit} className="mt-6">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Entrez votre adresse email"
                className="w-full px-4 py-3 bg-transparent text-white rounded-xl border border-white/40 focus:border-white/80 focus:outline-none placeholder:text-white/35"
                required
              />

              <div className="mt-6 flex justify-center">
                <button
                  type="submit"
                  disabled={loading}
                  className="inline-flex items-center gap-2 px-6 py-3 bg-white text-black rounded-lg font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <span>{loading ? 'Envoi...' : 'Envoyer l\'email'}</span>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M9 5l7 7-7 7"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>

              <div className="mt-6 text-center">
                <Link to="/login" className="text-white/60 hover:text-white transition">
                  Retour à la connexion
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ForgotPassword;
